import { render, staticRenderFns } from "./final_reportcard.vue?vue&type=template&id=5e014b66&"
import script from "./final_reportcard.vue?vue&type=script&lang=js&"
export * from "./final_reportcard.vue?vue&type=script&lang=js&"
import style0 from "./final_reportcard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports